import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation} from 'react-router-dom';
import { UserContext } from '../context/userContext';

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const {isTouched, setIsTouched} = useContext(UserContext);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setIsClicked(!isClicked);
  };

  const handleMenu = (path) =>{
    (location.pathname === path) && setIsOpen(!isOpen)
  }

  useEffect(() => {
    if (isTouched) {
        setIsOpen(false); 
        setIsTouched(false);
        setIsClicked(false);
    }
}, [isTouched, setIsTouched]);

  return (
    <>
      <button onClick={toggleMenu} className={isClicked? "buttonStyle":"btnStyle"}>
        ☰
      </button>

      {isOpen && (
        <div className={`menu ${isOpen ? 'open' : ''}`}>
          <ul>
            <Link to={'/work'} className='link resLink' onClick={()=>handleMenu('/work')}>
              <li>Work</li>
            </Link>

            <Link to={'/aboutMe'} className='link resLink' onClick={()=>handleMenu('/aboutMe')}>
              <li>About</li>
            </Link>

            <Link to={'/contactMe'} className='link resLink' onClick={()=>handleMenu('/contactMe')}>
              <li>Contact</li>
            </Link>
          </ul>
        </div>
      )}
    </>
  );
}